var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.carItems.length > 0)?_c('v-menu',{attrs:{"offset-y":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-badge',{attrs:{"color":"primary","content":_vm.carItems.length}},[_c('v-icon',_vm._g(_vm._b({on:{"click":_vm.getListCar}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icons.mdiCartOutline)+" ")])],1)]}}],null,false,1551629791)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }